import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { space, color, H1, H3, device } from '@ticketswap/solar'

const Container = styled.div`
  margin-bottom: ${space[24]};
  text-align: ${props => props.align};
  margin-top: ${space[32]};

  @media ${device.tablet} {
    margin-bottom: ${space[32]};
  }
`

const StyledH1 = styled(H1)`
  transform: ${props => props.align === 'left' && 'translateX(-1px)'};

  @media ${device.tablet} {
    transform: ${props => props.align === 'left' && 'translateX(-2px)'};
  }
`

const StyledH3 = styled(H3)`
  margin-top: ${space[16]};
  color: ${color.spaceMedium};

  strong {
    color: ${color.space};
  }

  span {
    a {
      color: ${color.spaceMedium};
    }
  }
`

export const PageTitle = ({ primary, secondary, ...props }) => (
  <Container {...props}>
    <StyledH1 align={props.align}>{primary}</StyledH1>
    {secondary && <StyledH3>{secondary}</StyledH3>}
  </Container>
)

PageTitle.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  align: PropTypes.oneOf(['left', 'center', 'right']),
}

PageTitle.defaultProps = {
  align: 'left',
}
